/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-18 11:34:41
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-16 14:27:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/SalesChannelEditorProductSearch.tsx
 */
import React from 'react';

import css from './css.less';

import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';

//import { useParams } from 'react-router-dom';
import { dispatch } from 'src/store';

//import { IParams } from 'src/pages/SalesChannelContentEditor/common';
import { ChannelType } from 'src/types/common/SalesChannel';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import CloneBtn from './CloneButton';
import EnableConfig from './EnableConfig';
import FeaturedProducts from './FeaturedProduct';
import HotTags from './HotTags';
import MiniInfo from './MiniInfo';
import MiniShare from './MiniShare';
import Preview from './Preview';
import RouteBlock from './RouteBlock';
import SearchBarPlaceHolder from './SearchBarPlaceHolder';

import { useDispatch, useSelector } from 'react-redux';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import NonPrimaryTip from 'src/pages/SalesChannelContentEditor/Components/DisabledSectionTip';
import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/tools';
import { SalesChannelModeAccessControlHOC } from '@/src/constrains/SalesChannelModeAccessControl';
import { DEFAULT_MULTI_LANGUAGE_PARAMS } from '@/src/types/server/params';
import { i18nGet } from 'src/tools/tools';
import TranslationTip from 'src/constrains/SalesChannelAITranslation/TranslationTip';
import styles from './css.less';

import {
  fetchContentSearchPage,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getTranslationState,
  resetData,
  submitContentHomepage,
  validation,
  translateContentProductSearchPage,
} from './slice';
const SalesChannelEditorProductSearch = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    isOnPrimaryLanguage,
    loaded,
    isMini,
    translationEnabled,
    translationLoading,
    uuid,
  } = props;
  const hideRightPart = !isMini;
  const _d = useDispatch();
  const type = useSalesChannelType();

  const multiLanguageParams = DEFAULT_MULTI_LANGUAGE_PARAMS;
  React.useEffect(() => {
    return () => {
      _d(resetData());
    };
  }, []);

  const handleOnTranslate = (translationEnabled) => {
    _d(
      translateContentProductSearchPage({
        uuid,
        translationEnabled,
        multiLanguageParams,
      }),
    );
  };

  const enabled = useSelector(
    (state: any) => state.salesChannelContent.productSearch.enabled,
  );

  const _leftChild = (
    <div className={css.left}>
      {translationEnabled && !isOnPrimaryLanguage && (
        <div className={styles.translationTip}>
          <TranslationTip />
        </div>
      )}
      <Preview
        wrapperClassName={translationEnabled ? styles.wrapperMarginTop : ''}
      />
    </div>
  );

  const WrappedProductSearchContent = React.useMemo(() => {
    return SalesChannelModeAccessControlHOC(
      () => {
        return (
          <>
            {translationEnabled && !isOnPrimaryLanguage && !isMini && (
              <TranslationTip />
            )}

            <RightConfigWrapper
              wrapperClassName={hideRightPart ? 'wrapperWithoutLeft' : ''}
              title={getI18n('salesChannelContent.index.productSearchPage')}
              elements={[
                {
                  body: (
                    <Comp
                      enabled={enabled}
                      isPrimary={isOnPrimaryLanguage}
                      type={type}
                      withoutCollapse={hideRightPart}
                      translationEnabled={translationEnabled}
                    />
                  ),
                  key: 'TopConfig',
                },
              ]}
            />
          </>
        );
      },
      { isscMode: true },
    );
  }, [
    translationEnabled,
    isOnPrimaryLanguage,
    isMini,
    hideRightPart,
    enabled,
    type,
  ]);

  const _rightChild = loaded ? <WrappedProductSearchContent /> : null;

  const leftChild = hideRightPart ? _rightChild : _leftChild;
  const rightChild = hideRightPart ? null : _rightChild;

  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
          hasStyleSelect: false,
          handleOnTranslate,
          translationEnabled,
          translationLoading,
        }}
        hideRightPart={hideRightPart}
        withoutCollapse={hideRightPart}
        leftChild={leftChild}
        rightChild={rightChild}
      />
    </React.Fragment>
  );
};
export default BasicPageHOC(SalesChannelEditorProductSearch, {
  siteStyleInParams: true,
  previewSizeInParams: true,
  getState,
  convertDataFromReduxToServer,
  submit: submitContentHomepage,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  getTranslationState,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchContentSearchPage({
        //1===true 0===false
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
const Comp = React.memo(
  ({ enabled, isPrimary, type, withoutCollapse, translationEnabled }: any) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const _miniProgramRender = () => {
      if (isPrimary) {
        if (enabled) {
          return (
            <React.Fragment>
              <HotTags />
              <SearchBarPlaceHolder isPrimary={isPrimary} />
              <FeaturedProducts isPrimary={isPrimary} />
              <MiniShare />
              <MiniInfo />
            </React.Fragment>
          );
        }
        return null;
      } else {
        if (enabled) {
          return (
            <React.Fragment>
              <CloneBtn disabled={translationEnabled} />
              <HotTags disabled={translationEnabled} />
              <SearchBarPlaceHolder
                isPrimary={isPrimary}
                disabled={translationEnabled}
              />
              <FeaturedProducts
                isPrimary={isPrimary}
                disabled={translationEnabled}
              />
              <MiniShare disabled={translationEnabled} />
              <MiniInfo />
            </React.Fragment>
          );
        }
        return (
          <div className={css.nonPrimaryTip}>
            <NonPrimaryTip tip='Enable product search under primary language' />
          </div>
        );
      }
    };

    const _websiteRender = () => {
      if (isPrimary) {
        if (enabled) {
          return (
            <React.Fragment>
              <HotTags collapseOpenDefault={withoutCollapse} />
              <SearchBarPlaceHolder
                isPrimary={isPrimary}
                collapseOpenDefault={withoutCollapse}
              />
              <FeaturedProducts
                isPrimary={isPrimary}
                collapseOpenDefault={withoutCollapse}
              />
            </React.Fragment>
          );
        }
        return null;
      } else {
        if (enabled) {
          return (
            <React.Fragment>
              <CloneBtn disabled={translationEnabled} />
              <HotTags
                collapseOpenDefault={withoutCollapse}
                disabled={translationEnabled}
              />
              <SearchBarPlaceHolder
                isPrimary={isPrimary}
                collapseOpenDefault={withoutCollapse}
                disabled={translationEnabled}
              />
              <FeaturedProducts
                isPrimary={isPrimary}
                collapseOpenDefault={withoutCollapse}
              />
            </React.Fragment>
          );
        }
        return (
          <div className={css.nonPrimaryTip}>
            <NonPrimaryTip
              tip={getI18n('salesChannelContent.index.nonPrimaryTip')}
            />
          </div>
        );
      }
    };

    const renderContent = () => {
      if (type === ChannelType.MiniProgram) {
        return _miniProgramRender();
      }
      if (type === ChannelType.Website) {
        return _websiteRender();
      }
      return null;
    };
    const Components = React.useMemo(() => {
      return renderContent();
    }, [enabled, isPrimary, type, withoutCollapse, translationEnabled]);
    return (
      <React.Fragment>
        {isPrimary && <EnableConfig withoutCollapse={withoutCollapse} />}
        {Components}
      </React.Fragment>
    );
  },
);
